/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { registry } from '@/lib/registry';

// STATIC_REGISTRY_START

/* eslint-disable */
/**
 * Initialize the static component registry.
 * This function is auto-generated by the staticRegistry Vite plugin.
 * 
 * DO NOT EDIT THIS FUNCTION MANUALLY - it will be overwritten on next build.
 * 
 * Components registered: Content.contentCard, Content.hero, Content.imageTextOverlay, Content.pdImage, Content.popularCategory, Content.productRecommendations, Content.productTile, Content.promoBadge, Layout.grid, Layout.heroCarousel, Layout.popularCategories, Layout.productCarousel, storefrontnext_base.markupContent
 */
export function initializeRegistry(targetRegistry = registry): void {
    targetRegistry.registerImporter('Content.contentCard', () => import('../components/content-card/index'));
    targetRegistry.registerImporter('Content.hero', () => import('../components/hero/index'));
    targetRegistry.registerImporter('Content.imageTextOverlay', () => import('../components/image-text-overlay/index'));
    targetRegistry.registerImporter('Content.pdImage', () => import('../components/dynamic-image/index'));
    targetRegistry.registerImporter('Content.popularCategory', () => import('../components/home/popular-category/index'), { loader: 'loader' });
    targetRegistry.registerImporter('Content.productRecommendations', () => import('../components/product-recommendations/index'));
    targetRegistry.registerImporter('Content.productTile', () => import('../components/product-tile/index'), { loader: 'loader' });
    targetRegistry.registerImporter('Content.promoBadge', () => import('../components/promo-badge/index'));
    targetRegistry.registerImporter('Layout.grid', () => import('../components/grid/index'));
    targetRegistry.registerImporter('Layout.heroCarousel', () => import('../components/hero-carousel/index'), { fallback: 'fallback' });
    targetRegistry.registerImporter('Layout.popularCategories', () => import('../components/home/popular-categories/index'), { loader: 'loader' });
    targetRegistry.registerImporter('Layout.productCarousel', () => import('../components/product-carousel/index'), { loader: 'loader', fallback: 'fallback' });
    targetRegistry.registerImporter('storefrontnext_base.markupContent', () => import('../components/markup-content/index'));
}

// STATIC_REGISTRY_END
